import { getProductsForSubstance as getProductsForSubstanceSelector } from '@Containers/RcsResults/RcsResultsSelectors';
import { isResultChecked as isResultCheckedSelector } from '@Pages/Results/selectors';
import {
  setProductChecked as setProductCheckedAction,
  setProductsCheckedForSubstance as setProductsCheckedForSubstanceAction,
} from '@Pages/Results/actions';

// eslint-disable-next-line import/prefer-default-export
export const setChecked =
  ({ substanceId, substanceIndex, productId, productIndex }, checked) =>
  (dispatch, getState) => {
    const state = getState();
    const isResultChecked = isResultCheckedSelector(state, { index: substanceIndex });

    if (!isResultChecked) {
      // Check individual product
      dispatch(
        setProductCheckedAction(
          {
            substanceId,
            substanceIndex,
            productId,
            productIndex,
          },
          checked
        )
      );
    } else {
      // Check all products for substance except the current one
      const products = getProductsForSubstanceSelector(state, { substanceId });
      dispatch(
        setProductsCheckedForSubstanceAction({
          products: products
            .map(({ index, rcSubstanceId }) => ({
              substanceId,
              substanceIndex,
              productId: rcSubstanceId,
              productIndex: index,
            }))
            .filter(({ productId: currentProductId }) => currentProductId !== productId),
          substanceIndex,
        })
      );
    }
  };
